import {createGlobalStyle, css} from 'styled-components';

export const GlobalStyle = createGlobalStyle`${css`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
`}`;
